class ACL {
  constructor() {
    this.ROLE = {
      ADM: 'ADM', // administrator
      GEM: 'GEM', // general manager
      COL: 'COL', // colaborador
      PAG: 'PAG', // pagos
      ENT: 'ENT', // entregas
      CLI: 'CLI', // cliente
      LAB: 'LAB', // laboratorio
      DIST: 'DIST', // distribuidor
    }
  }

  isAdmin(role) {
    return (
      role === this.ROLE.GEM || role === this.ROLE.COL || role === this.ROLE.ADM
    )
  }

  isManager(role) {
    return role === this.ROLE.GEM
  }

  isDelivery(role) {
    return role === this.ROLE.ENT
  }

  isClient(role) {
    return role === this.ROLE.CLI
  }

  isLaboratory(role) {
    return role === this.ROLE.LAB
  }

  isDistributor(role) {
    return role === this.ROLE.DIST
  }

  isAccounting(role) {
    return role === this.ROLE.PAG
  }
}

export default new ACL()
